export default __webpack_public_path__ + "static/media/IRANSansWeb.94a3bf44.ttf";